import type { GetV1Scenarios200, GetV1ScenariosQueryResponse } from '../models'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { scenarioSchema } from './scenarioSchema'
import { z } from 'zod'

/**
 * @description The list of scenarios
 */
export const getV1Scenarios200Schema = z.object({
  count: z.number().min(0),
  data: z.array(z.lazy(() => scenarioSchema)),
}) as unknown as ToZod<GetV1Scenarios200>

export type GetV1Scenarios200Schema = GetV1Scenarios200

export const getV1ScenariosQueryResponseSchema = z.lazy(() => getV1Scenarios200Schema) as unknown as ToZod<GetV1ScenariosQueryResponse>

export type GetV1ScenariosQueryResponseSchema = GetV1ScenariosQueryResponse